var _a;
import { createSlice } from '@reduxjs/toolkit';
import * as reducers from './reducers';
import { buildInitialState } from './initial-state';
var bannerSlice = createSlice({
    name: 'banners',
    initialState: buildInitialState(),
    reducers: reducers,
});
export var bannerReducer = bannerSlice.reducer, showBanner = (_a = bannerSlice.actions, _a.showBanner), hideBanner = _a.hideBanner;
